module.exports = __webpack_public_path__ + "static/media/thumbnail.8fd19d19.jpg";